export default __webpack_public_path__ + "media/images/transfers_hero-a48a1cfd62cb4082e304a108ec829eec.jpg";